import { createSelector } from 'reselect';

import { separateOfficeSelector } from 'shared/store/coworking/selectors/smart/separateOfficeSelector';

export const separateOfficeWithErrorSelector = createSelector(separateOfficeSelector, offer => {
  if (!offer) {
    throw new Error('separateOfficeWithErrorSelector Офер не был передан');
  }

  return offer;
});
